import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
	getTrackedPage,
	getTracksAtomicClientId,
	recordWPCloudPortalPageView,
} from './wpcloud';

let lastTrackedPageViewKey: string | null = null;

export default function usePageViewTracks() {
	const location = useLocation();

	useEffect( () => {
		const page = getTrackedPage( location.pathname );
		const atomicClientId = getTracksAtomicClientId(
			new URLSearchParams( location.search )
		);
		const trackingKey = [
			page.page,
			page.pagePath,
			page.sitePerformanceTab ?? '',
			atomicClientId ?? '',
		].join( ':' );

		if ( lastTrackedPageViewKey === trackingKey ) {
			return;
		}

		lastTrackedPageViewKey = trackingKey;

		recordWPCloudPortalPageView( page, {
			atomic_client_id: atomicClientId,
		} );
	}, [ location.pathname, location.search ] );
}
